import React, { useState } from "react";
import { SelectChangeEvent, TextField, MenuItem, Select, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import EditText from "../../components/editText";

const AddEmailTemplate = () => {

  const navigate = useNavigate();
  const [eventType, setEventType] = React.useState('default');
  const handleEventTypeChange = (event: SelectChangeEvent) => {
    setEventType(event.target.value as string);
  };
  const [legal1, setLegal1] = useState<string>("");

  return (
    <>
      <div className="main_title">
        <h1>Add Email Template</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - {" "}
          <button onClick={() => navigate("/manage-system-settings")}>System Settings</button> -
          Add Email Template
        </p>
      </div>

      <div className="cards">
        <form className="form" action="">
          <div className="gap_p">
            <div className="control_group w_50">
              <label htmlFor="temp_name">Template Name</label>
              <TextField
                id="temp_name"
                placeholder="Enter Template Name"
                fullWidth
                hiddenLabel
              />
            </div>
            <div className="control_group w_50">
              <label htmlFor="temp_eventType">Event Type</label>
              <Select
                id="temp_eventType"
                fullWidth
                value={eventType}
                onChange={handleEventTypeChange}
              >
                <MenuItem disabled value="default">Select Event Type</MenuItem>
                <MenuItem value="1">welcome_email</MenuItem>
                <MenuItem value="2">otp_verification</MenuItem>
                <MenuItem value="2">reset_password</MenuItem>
              </Select>
            </div>
            <div className="control_group w_100">
              <label htmlFor="temp_title">Title</label>
              <TextField
                id="temp_title"
                placeholder="Enter Title"
                fullWidth
                hiddenLabel
              />
            </div>
            <div className="control_group w_100">
              <label htmlFor="temp_message">Message</label>
              <EditText content={legal1} setContent={setLegal1} />
            </div>
          </div>
          <div className="form_btn">
            <Button className="btn btn_primary" onClick={() => navigate('/manage-notifications')}>Submit</Button>
          </div>
        </form>
      </div>
    </>
  );
};

export default AddEmailTemplate;
